// extracted by mini-css-extract-plugin
export default {"reschedule-page__body":"_1MztSmehrv-nwjgC1eB31"};